import type { AppApi } from '@wix/wix-data-client-common'
import {
  generate as patternDefGenerate,
  getPageName,
  MAIN_SLUG_PATTERN,
  PAGE_TYPES,
} from '@wix/wix-data-client-common'
import type { EditorSDK } from '@wix/wix-data-client-common-standalone'
import type { Schema } from '@wix/wix-data-schema-types'
import { createPrefixWithSafelyClearedStaticPageUriSEO } from '../add-dynamic-pages/prepareDataForPages'
import { generateUniquePrefix } from '../generateUniquePrefix'

const BLANK_PAGE_ROUTE_TEMPLATE = {
  config: {
    pageSize: 1,
  },
}

export const prepareDataForBlankPageEditor3 = async ({
  editorSdkProxy,
  appApi,
  schema,
}: {
  editorSdkProxy: EditorSDK
  appApi: AppApi
  schema: Schema
}) => {
  const routerPrefix = await createPrefixWithSafelyClearedStaticPageUriSEO({
    editorSdkProxy,
    pagesToAdd: [{ key: 'itemPage' }],
    createPrefix: () =>
      generateUniquePrefix({
        inputsForPrefix: [schema.displayName, schema.id],
        editorSdkProxy,
        appApi,
        pageType: PAGE_TYPES.ITEM,
      }),
  })

  const pattern = MAIN_SLUG_PATTERN

  const routeDefinition = patternDefGenerate({
    routeDefinitionBase: BLANK_PAGE_ROUTE_TEMPLATE,
    pattern,
    collectionId: schema.id,
    seoV2: true,
  })

  const pageTitle = getPageName({
    collectionName: schema.displayName,
    pattern,
  })

  return { routeDefinition, pageTitle, routerPrefix, pattern }
}
